// Port of api/fuel/app/classes/controller/api/monty/games/expansions.php
import { buildExpansionsResponse } from 'offline/api/games/shared'

export default function(params) {
	return buildExpansionsResponse(params)
}
